import {
  PO_SEARCH_OPPORTUNITIES_REQUEST,
  PO_SEARCH_OPPORTUNITIES_SUCCESS,
  PO_SEARCH_OPPORTUNITIES_ERROR,
  PO_SEARCH_OPPORTUNITIES_RESET,
} from "redux/actions/action-type";

const initialState = {
  searchOrderOpportunitiesData: {},
  searchOpportunitiesError: {},
  searchOpportunitiesMetadata: {},
  isPOSearchOpportunitiesLoading: false,
  isPOSearchOpportunitiesError: false,
  isPOSearchOpportunitiesSuccess: false,
};

const poSearchOpportunitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case PO_SEARCH_OPPORTUNITIES_REQUEST:
      return {
        ...state,
        isPOSearchOpportunitiesLoading: true,
        isPOSearchOpportunitiesError: false,
        isPOSearchOpportunitiesSuccess: false,
      };

    case PO_SEARCH_OPPORTUNITIES_SUCCESS:
      return {
        ...initialState,
        isPOSearchOpportunitiesLoading: false,
        searchOrderOpportunitiesData: action.payload,
        searchOpportunitiesMetadata: action.payload,
        isPOSearchOpportunitiesError: false,
        isPOSearchOpportunitiesSuccess: true,
        searchOpportunitiesError: {},
      };

    case PO_SEARCH_OPPORTUNITIES_ERROR:
      return {
        ...state,
        isPOSearchOpportunitiesLoading: false,
        searchOrderOpportunitiesData: {},
        isPOSearchOpportunitiesError: true,
        isPOSearchOpportunitiesSuccess: false,
        searchOpportunitiesError: action.payload,
      };

    case PO_SEARCH_OPPORTUNITIES_RESET:
      return {
        ...initialState
      }

    default:
      return state;
  }
};

export default poSearchOpportunitiesReducer;
